import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../../config/AxiosConfig'
import { ProjectConfigListResp } from 'domain/payload/response/clientTransmora/projectConfig/ProjectConfigListResp';
import { ProjectConfigDetailResp } from 'domain/payload/response/clientTransmora/projectConfig/ProjectConfigDetailResp';
import { ProjectConfigConfigResp } from 'domain/payload/response/clientTransmora/projectConfig/ProjectConfigConfigResp';
import { ProjectConfigCreateReq } from 'domain/payload/request/clientTransmora/projectConfig/ProjectConfigCreateReq';
import { ProjectConfigUpdateReq } from 'domain/payload/request/clientTransmora/projectConfig/ProjectConfigUpdateReq';
import { ProjectConfigKeyConfigResp } from 'domain/payload/response/clientTransmora/projectConfig/ProjectConfigKeyConfigResp';

const ProjectConfigService = () => {
  const ProjectConfigList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null
  ): Promise<BaseResponse<ProjectConfigListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/client-project-config/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search,
          page: page,
          size: size
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const ProjectConfigDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<ProjectConfigDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/client-project-config/detail?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const ProjectConfigExecute = async (
    token: string,
    id: string
  ): Promise<any> => {
    try {
      const response = await axiosInstance.post(
        `/v1/legacy/cms/client-project-config/execute`,
        { id },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const ProjectConfigConfig = async (
    token: string,
    excludeId: string | undefined
  ): Promise<BaseResponse<ProjectConfigConfigResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/client-project-config/config`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          excludeId: excludeId
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const ProjectConfigCreate = async (
    token: string,
    request: ProjectConfigCreateReq
  ): Promise<BaseResponse<ProjectConfigDetailResp>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/client-project-config/create`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const ProjectConfigUpdate = async (
    token: string,
    request: ProjectConfigUpdateReq
  ): Promise<BaseResponse<ProjectConfigDetailResp>> => {
    try {
      console.log("Final payload:", JSON.stringify(request, null, 2));
      const response = await axiosInstance.put(`/v1/legacy/cms/client-project-config/update`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        },
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const ProjectConfigDelete = async (
    token: string,
    id: string
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.delete(
        `/v1/legacy/cms/client-project-config/delete`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { id },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const ProjectConfigKeyConfig = async (
    token: string,
    id: string,
    search: string | null,
  ): Promise<BaseResponse<ProjectConfigKeyConfigResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/client-project-config/key-config?projectId=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  return { ProjectConfigList, ProjectConfigDetail, ProjectConfigExecute, ProjectConfigConfig, ProjectConfigCreate, ProjectConfigUpdate, ProjectConfigDelete, ProjectConfigKeyConfig };
};

export default ProjectConfigService;